export default __webpack_public_path__ + "static/media/likeColored.688e1c56.svg";